import "./../../../bindings/bao-searcher";
import "./../../../bindings/bao-toolbar2";
class ColumnProfileFieldsTabDialog {
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck() {
        return null;
    }
}
export default ColumnProfileFieldsTabDialog;